import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** 1 … 4 5 6 … 330: the first, the last, and the current page's neighbours. */
function pageWindow(current: number, last: number) {
  if (last <= 7) return Array.from({
    length: last
  }, (_, i) => i + 1);
  const pages: number[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(last - 1, current + 1);
  if (start > 2) pages.push(-1);
  for (let p = start; p <= end; p += 1) pages.push(p);
  if (end < last - 1) pages.push(-2);
  pages.push(last);
  return pages;
}

/** Page state is local, as it was: `?page=` belongs to the Items tab. So the
 *  pager is buttons, not links — there is no URL to link to — with the same
 *  numbered window as the site's link pagination, so any page is one press
 *  away rather than a walk through Previous/Next. */
export default function Pager(t0) {
  const $ = _c(46);
  const {
    page,
    last,
    busy,
    onPage,
    isFa
  } = t0;
  if (last <= 1) {
    return null;
  }
  let Next;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== busy || $[1] !== isFa || $[2] !== last || $[3] !== onPage || $[4] !== page) {
    const nf = new Intl.NumberFormat(isFa ? "fa-IR" : "en-US");
    const Prev = isFa ? ChevronRight : ChevronLeft;
    Next = isFa ? ChevronLeft : ChevronRight;
    t2 = "v2-cd-pager";
    t3 = isFa ? "\u0635\u0641\u062D\u0647\u200C\u0628\u0646\u062F\u06CC \u0622\u0641\u0631\u0647\u0627" : "Offers pages";
    t4 = busy || undefined;
    let t6;
    if ($[11] !== onPage || $[12] !== page) {
      t6 = () => onPage(page - 1);
      $[11] = onPage;
      $[12] = page;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    const t7 = page <= 1;
    const t8 = isFa ? "\u0635\u0641\u062D\u0647\u0654 \u0642\u0628\u0644\u06CC" : "Previous page";
    let t9;
    if ($[14] !== Prev) {
      t9 = <Prev aria-hidden={true} />;
      $[14] = Prev;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    const t10 = isFa ? "\u0642\u0628\u0644\u06CC" : "Previous";
    let t11;
    if ($[16] !== t10) {
      t11 = <span className="v2-cd-pager-label">{t10}</span>;
      $[16] = t10;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    if ($[18] !== t11 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
      t5 = <button type="button" className="v2-focus" onClick={t6} disabled={t7} aria-label={t8}>{t9}{t11}</button>;
      $[18] = t11;
      $[19] = t6;
      $[20] = t7;
      $[21] = t8;
      $[22] = t9;
      $[23] = t5;
    } else {
      t5 = $[23];
    }
    t1 = pageWindow(page, last).map(p => p < 0 ? <li key={p} aria-hidden={true}>…</li> : <li key={p}><button type="button" className="v2-focus" onClick={() => onPage(p)} aria-current={p === page ? "page" : undefined} aria-label={isFa ? `صفحهٔ ${nf.format(p)}` : `Page ${p}`}>{nf.format(p)}</button></li>);
    $[0] = busy;
    $[1] = isFa;
    $[2] = last;
    $[3] = onPage;
    $[4] = page;
    $[5] = Next;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    Next = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[24] !== t1) {
    t6 = <ol>{t1}</ol>;
    $[24] = t1;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== onPage || $[27] !== page) {
    t7 = () => onPage(page + 1);
    $[26] = onPage;
    $[27] = page;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  const t8 = page >= last;
  const t9 = isFa ? "\u0635\u0641\u062D\u0647\u0654 \u0628\u0639\u062F\u06CC" : "Next page";
  const t10 = isFa ? "\u0628\u0639\u062F\u06CC" : "Next";
  let t11;
  if ($[29] !== t10) {
    t11 = <span className="v2-cd-pager-label">{t10}</span>;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== Next) {
    t12 = <Next aria-hidden={true} />;
    $[31] = Next;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t11 || $[34] !== t12 || $[35] !== t7 || $[36] !== t8 || $[37] !== t9) {
    t13 = <button type="button" className="v2-focus" onClick={t7} disabled={t8} aria-label={t9}>{t11}{t12}</button>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t13 || $[40] !== t2 || $[41] !== t3 || $[42] !== t4 || $[43] !== t5 || $[44] !== t6) {
    t14 = <nav className={t2} aria-label={t3} aria-busy={t4}>{t5}{t6}{t13}</nav>;
    $[39] = t13;
    $[40] = t2;
    $[41] = t3;
    $[42] = t4;
    $[43] = t5;
    $[44] = t6;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  return t14;
}